Drupal.behaviors.materialIcons = {
    attach(context) {
        document.fonts.ready.then(() => {
            once('material-icons', '.material-symbols-rounded', context).forEach((icon) => {
                icon.classList.add('loaded');
            });
        });
    },
};
